module.exports = __webpack_public_path__ + "img/35_3.7bcae810.png";